/* Learn: mobile product bar and the learn_product_click event. No dependencies. */
(function () {
  // Every Learn product button carries data-learn-cta, data-product-handle and data-article-handle.
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-learn-cta]');
    if (!el) return;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('learn_product_click', {
          cta: el.getAttribute('data-learn-cta'),
          product_handle: el.getAttribute('data-product-handle'),
          article_handle: el.getAttribute('data-article-handle') || ''
        });
      }
    } catch (err) {}
  });

  // Compare page filter: chips are real links (tag pages) that filter the grid in place instead.
  var filter = document.querySelector('[data-learn-filter]');
  var list = document.querySelector('[data-learn-filter-list]');
  if (filter && list) {
    var items = list.querySelectorAll('li[data-topics]');
    var count = document.querySelector('[data-learn-filter-count]');
    filter.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-topic]');
      if (!chip) return;
      e.preventDefault();
      var topic = chip.getAttribute('data-topic');
      filter.querySelectorAll('[data-topic]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var shownCount = 0;
      items.forEach(function (li) {
        var match = !topic || (' ' + li.getAttribute('data-topics') + ' ').indexOf(' ' + topic + ' ') > -1;
        li.hidden = !match;
        li.classList.remove('is-lead');
        if (match && ++shownCount === 1) li.classList.add('is-lead');
      });
      if (count) {
        count.hidden = !topic;
        count.textContent = shownCount + (shownCount === 1 ? ' comparison' : ' comparisons');
      }
    });
  }

  // FAQ page search: filters the questions already in the page; opens matches, hides empty groups.
  var faqForm = document.querySelector('[data-learn-faq-search]');
  if (faqForm) {
    var faqInput = faqForm.querySelector('input');
    var faqItems = document.querySelectorAll('[data-learn-faq-item]');
    var faqGroups = document.querySelectorAll('[data-learn-faq-group]');
    var faqEmpty = document.querySelector('[data-learn-faq-empty]');
    var faqStatus = document.querySelector('[data-learn-faq-status]');
    faqForm.addEventListener('submit', function (e) { e.preventDefault(); });
    var runFaq = function () {
      var q = faqInput.value.trim().toLowerCase();
      var hits = 0;
      faqItems.forEach(function (d) {
        var match = !q || d.textContent.toLowerCase().indexOf(q) > -1;
        d.hidden = !match;
        if (match) hits++;
        if (q && match) d.open = true;
      });
      faqGroups.forEach(function (g) { g.hidden = !g.querySelector('[data-learn-faq-item]:not([hidden])'); });
      if (faqEmpty) faqEmpty.hidden = hits > 0;
      if (faqStatus) { faqStatus.hidden = !q; faqStatus.textContent = hits + (hits === 1 ? ' answer' : ' answers'); }
    };
    faqInput.addEventListener('input', runFaq);
  }

  // Mobile bar: shows after 25% of the page, hides while the cookie banner is open, can be dismissed.
  var bar = document.querySelector('[data-learn-bar]');
  if (!bar) return;
  var KEY = 'vvLearnBarClosed';
  var closed = false;
  try { closed = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
  if (closed) return;
  var focusables = bar.querySelectorAll('a, button');
  var shown = false;

  function cookieBannerOpen() {
    var b = document.querySelector('.cky-consent-container');
    return !!(b && !b.classList.contains('cky-hide') && b.offsetParent !== null);
  }
  function setShown(on) {
    if (on === shown) return;
    shown = on;
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    for (var i = 0; i < focusables.length; i++) focusables[i].tabIndex = on ? 0 : -1;
  }
  var ticking = false;
  function update() {
    ticking = false;
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var pct = max > 0 ? window.scrollY / max : 0;
    setShown(pct > 0.25 && pct < 0.97 && !cookieBannerOpen());
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  bar.querySelector('[data-learn-bar-close]').addEventListener('click', function () {
    setShown(false);
    try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
    bar.remove();
  });
})();
